import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, MarketingCard } from '@tvg/fuse-design';
import sendAnalyticsEventForTradeIn from 'utilities/tradeIn/tradeInUtilities';

const TradeInTitle = styled(TypographyElement)`
  color: var(--color-brand-700);
  font-size: var(--font-size-1);
`;

interface TradeInProps {
  tradeInValue: number;
}

const sendAnalyticsEvent = () => {
  sendAnalyticsEventForTradeIn({ gaLabel: 'MTRTradeIn' });
};

export default function TradeIn(props: TradeInProps) {
  const { tradeInValue } = props;
  return (
    <MarketingCard
      id="productTradeInMessage_link"
      header={
        <TradeInTitle type="heading" size={{ xxs: '1', m: '1', l: '2' }} tag="h2">
          Claim up to £{tradeInValue}* when you trade-in your old device
        </TradeInTitle>
      }
      linkText="Find out more from our Trade-in partner, MTR"
      linkUrl="https://verytradein.mtr.co.uk"
      newWindow
      onClick={() => sendAnalyticsEvent()}
      dataTestId="trade-in-card"
      paragraphText="*Trade-in price is dependent on make, model and condition of the device you're trading in"
    />
  );
}
